import { useCallback, useState } from 'react';
import Editor from '@monaco-editor/react';

import { InteractionStepType } from '@scale/shared/types/chat';
import { StepConfigurationComponentProps } from '../stepDescriptor/types';

export function JsonConfigurationComponent<T extends InteractionStepType>({
  params,
  setParams,
}: StepConfigurationComponentProps<T>) {
  const [rawJson, setRawJson] = useState(JSON.stringify(params, undefined, 2));
  const [errorMessage, setErrorMessage] = useState<string>('');

  const validateAndSetRawJson = useCallback(
    (value: string) => {
      setRawJson(value);
      try {
        setErrorMessage('');
        const newParams = JSON.parse(value);
        setParams(newParams);
      } catch (error) {
        setErrorMessage(error.message);
      }
    },
    [setErrorMessage, setParams, setRawJson],
  );

  return (
    <div>
      {errorMessage && (
        <div className="mb-4 text-danger-500 font-medium">Error: {errorMessage}</div>
      )}
      <div style={{ height: 200 }}>
        <Editor
          language="json"
          options={{
            automaticLayout: true,
            autoClosingBrackets: 'always',
            autoClosingQuotes: 'always',
            formatOnPaste: true,
            formatOnType: true,
            scrollBeyondLastLine: false,
            tabSize: 2,
            minimap: { enabled: false },
            lineNumbers: 'on',
            wordWrap: 'on',
          }}
          value={rawJson}
          onChange={text => {
            if (text === undefined) {
              return;
            }
            validateAndSetRawJson(text);
          }}
        />
      </div>
    </div>
  );
}
